import React, { } from "react";
import {
    Modal, Grid, Button
} from 'semantic-ui-react';

import { Constants } from '../../../../src/config/appConstants';
const AttachmentViewerComponent = props => {

    return (
        <Modal
            open={props.attachmentViewer.isModalVisible}
            onOpen={props.openModal}
            onClose={() => props.closeModal()}
            size='medium'
            closeIcon
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className="attachmentModal"
        >
            <Modal.Header className="headerColor text-color">Attachment</Modal.Header>
            <Modal.Content scrolling>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16} textAlign="center">
                            <img style={{maxWidth:'75vh'}} alt={props.attachmentViewer.attachmentName} src={Constants.DATA_BASE64 + props.attachmentViewer.attachmentContent} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Modal.Content>
            <Modal.Actions>
                <Button secondary className="backButtonSpacing" type="button" primary onClick={() => props.closeModal()}>Back</Button>
            </Modal.Actions>
        </Modal>
    );
}

export default AttachmentViewerComponent;

AttachmentViewerComponent.displayName = "AttachmentViewerComponent";